import { Directive, HostBinding } from '@angular/core';

@Directive({
  // eslint-disable-next-line
  selector: 'app-error-page-message',
})
export class ErrorPageMessageDirective {
  @HostBinding('class.error-page__message')
  wrapper = true;
}
